var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-dropdown-divider'),_c('b-dropdown-item',{on:{"click":_vm.show}},[_c('i',{staticClass:"icon-search"}),_vm._v(" Historial de busquedas ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }